/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NumberGroup } from './NumberGroup';
import {
    NumberGroupFromJSON,
    NumberGroupFromJSONTyped,
    NumberGroupToJSON,
} from './NumberGroup';

/**
 * Player picks for one of a panel's number pools (groups), tagged with which GDS number group the picks
 * belong to. A DRAW panel with a single pool (e.g. Pick 3) has one entry; a multi-pool game (Powerball,
 * 2by2) has one entry per group. A RAPID (keno) panel always has a single PRIMARY_WINNING pool.
 * @export
 * @interface ParsedNumberPool
 */
export interface ParsedNumberPool {
    /**
     * 
     * @type {Array<number>}
     * @memberof ParsedNumberPool
     */
    numberSelections: Array<number>;
    /**
     * 
     * @type {NumberGroup}
     * @memberof ParsedNumberPool
     */
    numberGroup: NumberGroup;
}



/**
 * Check if a given object implements the ParsedNumberPool interface.
 */
export function instanceOfParsedNumberPool(value: object): value is ParsedNumberPool {
    if (!('numberSelections' in value) || value['numberSelections'] === undefined) return false;
    if (!('numberGroup' in value) || value['numberGroup'] === undefined) return false;
    return true;
}

export function ParsedNumberPoolFromJSON(json: any): ParsedNumberPool {
    return ParsedNumberPoolFromJSONTyped(json, false);
}

export function ParsedNumberPoolFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParsedNumberPool {
    if (json == null) {
        return json;
    }
    return {
        
        'numberSelections': json['numberSelections'],
        'numberGroup': NumberGroupFromJSON(json['numberGroup']),
    };
}

export function ParsedNumberPoolToJSON(value?: ParsedNumberPool | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'numberSelections': value['numberSelections'],
        'numberGroup': NumberGroupToJSON(value['numberGroup']),
    };
}

